import { Templates } from '@/types/common';
import { CheckoutTemplate } from '@/types/boot';
import { type PaymentMethodType } from '@/types/boot';
export interface TemplateFeatures {
  showPaymentMethods: boolean;
  showExpressCheckout: boolean;
  autoSelectPaymentMethod: boolean;
  showDesktopViewer: boolean;
  centerContentOnDesktop: boolean;
  defaultDetailsOpen: boolean;
  showXButton: boolean;
  showBackground: boolean;
}

export const TemplateConfigurations: Record<Templates, TemplateFeatures> = {
  [Templates.Default]: {
    showPaymentMethods: true,
    showExpressCheckout: true,
    autoSelectPaymentMethod: false,
    showDesktopViewer: true,
    centerContentOnDesktop: false,
    defaultDetailsOpen: false,
    showXButton: true,
    showBackground: true,
  },
  [Templates.OnePayment]: {
    showPaymentMethods: false,
    showExpressCheckout: false,
    autoSelectPaymentMethod: true,
    showDesktopViewer: true,
    centerContentOnDesktop: true,
    defaultDetailsOpen: false,
    showXButton: true,
    showBackground: false,
  },
};

export const CheckoutTemplateToTemplatesMapping: Record<CheckoutTemplate, Templates> = {
  [CheckoutTemplate.SINGLE_PAYMENT_METHOD]: Templates.OnePayment,
};

export interface TemplateConfig {
  type: Templates;
  features: TemplateFeatures;
  onePaymentMethod?: PaymentMethodType;
  backgroundImageUrl?: string;
}

export const getTemplateConfig = (
  templateType: Templates,
  onePaymentMethod?: PaymentMethodType,
  backgroundImageUrl?: string
): TemplateConfig => {
  return {
    type: templateType,
    features: TemplateConfigurations[templateType],
    onePaymentMethod,
    backgroundImageUrl,
  };
};
